export default function cleanFormProps(originalProps, keysToClean) {
  const deletableKeys = [
  // FormComponent Mixin props
  'elementWrapperClassName', 'hasFeedback', 'help', 'label', 'labelClassName', 'rowClassName', 'layout', 'validatePristine', 'optional',
  // FormsyReact Mixin props
  'validationError', 'validationErrors', ...keysToClean];
  const updatedProps = {
    ...originalProps
  };
  deletableKeys.forEach(prop => delete updatedProps[prop]);
  return updatedProps;
}